import { AppPermissions } from '../../entities/entitlements-v1/authorizations-parameters';

export interface authorizations {
  catrecid: string;
  applicationId: string;
  clientId: string;
  clientType: string;
  primaryPartyType: string;
  appPermissions: AppPermissions;
}

export interface Entitlements {
  authorizations: authorizations | null;
  loading: boolean;
  error: boolean;
}

export interface CurrentUserRole {
  userRoleName: string;
  loading: boolean;
  error: boolean;
}

export enum EntitlementNames {
  SET_AUTHORIZATIONS = 'SET_AUTHORIZATIONS',
  SET_LOADING = 'SET_LOADING',
  SET_ERROR = 'SET_ERROR',
}

interface SetAuthorizations {
  type: typeof EntitlementNames.SET_AUTHORIZATIONS;
  payload: authorizations;
}

interface SetLoading {
  type: typeof EntitlementNames.SET_LOADING;
  payload: boolean;
}

interface SetError {
  type: typeof EntitlementNames.SET_ERROR;
  payload: boolean;
}

export type EntitlementsActionTypes = SetAuthorizations | SetLoading | SetError;

export enum CurrentUserRoleNames {
  SET_CURRENT_USER_ROLE = 'SET_CURRENT_USER_ROLE',
  SET_CURRENT_USER_ROLE_LOADING = 'SET_CURRENT_USER_ROLE_LOADING',
  SET_CURRENT_USER_ROLE_ERROR = 'SET_CURRENT_USER_ROLE_ERROR',
}

interface SetCurrentUserRole {
  type: typeof CurrentUserRoleNames.SET_CURRENT_USER_ROLE;
  userRoleName: string;
}

interface SetCurrentUserRoleLoading {
  type: typeof CurrentUserRoleNames.SET_CURRENT_USER_ROLE_LOADING;
  loading: boolean;
}

interface SetCurrentUserRoleError {
  type: typeof CurrentUserRoleNames.SET_CURRENT_USER_ROLE_ERROR;
  error: boolean;
}

export type CurrentUserRoleActionTypes = SetCurrentUserRole | SetCurrentUserRoleLoading | SetCurrentUserRoleError;
